export const NumberOfTermsValues = Array.from({length:20},(v,i)=>(i+1)*12);
